export default {
  "content": "<circle cx=\"18\" cy=\"18\" r=\"16\" fill=\"#C9CBD4\" stroke=\"#fff\" stroke-width=\"4\"/><g clip-path=\"url(#a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 20a2 2 0 110-4 2 2 0 010 4zm-6 0a2 2 0 110-4 2 2 0 010 4zm-8-2a2 2 0 104 0 2 2 0 00-4 0z\" fill=\"#fff\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"rotate(90 8 18)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "36",
    "height": "36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};